import type { DotProps } from "@/v2-backoffice-client/components/dot"

const USER_ACTIVITY_LEVEL_DAILY = 1
const USER_ACTIVITY_LEVEL_WEEKLY = 2
const USER_ACTIVITY_LEVEL_MONTHLY = 3
const USER_ACTIVITY_LEVEL_INACTIVE = 4
const USER_ACTIVITY_LEVEL_UNKNOWN = 5

const USER_ACTIVITY_LEVEL_STYLES: Record<number, DotProps["variant"]> = {
  [USER_ACTIVITY_LEVEL_DAILY]: "success-1",
  [USER_ACTIVITY_LEVEL_WEEKLY]: "success-2",
  [USER_ACTIVITY_LEVEL_MONTHLY]: "warning",
  [USER_ACTIVITY_LEVEL_INACTIVE]: "destructive",
  [USER_ACTIVITY_LEVEL_UNKNOWN]: "secondary",
}

export function getUserActivityLevelVariant(code: number): DotProps["variant"] {
  return USER_ACTIVITY_LEVEL_STYLES[code] ?? "secondary"
}

/**
 * The Activity column's filter options, values as the level codes (what the
 * column's accessor holds), so a client-side table matches them as-is and a
 * server-side table sends them to its filter registry unchanged.
 */
export const USER_ACTIVITY_LEVEL_FILTER_OPTIONS = [
  { label: "Daily", value: String(USER_ACTIVITY_LEVEL_DAILY) },
  { label: "Weekly", value: String(USER_ACTIVITY_LEVEL_WEEKLY) },
  { label: "Monthly", value: String(USER_ACTIVITY_LEVEL_MONTHLY) },
  { label: "Inactive", value: String(USER_ACTIVITY_LEVEL_INACTIVE) },
  { label: "Unknown", value: String(USER_ACTIVITY_LEVEL_UNKNOWN) },
]
